<template>

  <section class="feature section" id="feature">

    <div class="container">
      <div class="row">

        <div class="heading col-12">
            <h3>Big things are <strong class="color-2">happening</strong></h3>
            <h4 class="legend">When we build strong relationships with our partners, step by step: being responsible with the projects, making our processes very transparent and offering excellent results.</h4>
        </div>

        <div class="work__w col-12">
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">We do apps</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">We have the required experience that our partners need in order to build an outstanding product at sight.</div>
                </div>
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">We do agile</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">We intensify our knowledge, improve our internal processes, clutter out our inefficiency and build the best possible product.</div>
                </div>
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">We design</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">From drawing in plain paper to adding UI animations and interactions, we design prototypes from the ground up. You being part of it in every step.</div>
                </div>
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">We focus on you</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">We get involved with your needs, featuring fully dedicated development teams. From the very beginning of the project, you have total control.</div>
                </div>
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">Continuous integration</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">Every commit that we finish could perfectly end up in a release pipeline. Our software development techniques reduces risks. </div>
                </div>
                <div class="work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h4 class="title" style="-webkit-backface-visibility: visible; z-index: 0; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">Our mojo</h4>
                    <div class="line__w">
                        <div class="line" style="width: 140px;"></div>
                    </div>
                    <div class="text" style="-webkit-backface-visibility: visible; opacity: 0.800000011920929; transform: matrix(1, 0, 0, 1, 0, 0);">We keep things clear and simple. We follow the best industry practices in order to maintain our products easy to scale over time.</div>
                </div>
          </div>
      </div>
    </div>


  </section>

</template>

<script>
export default {
  name: 'Features',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feature.section {
  background-color:#131418;
  padding-bottom: 100px; }

.work__w {
    border-top: 2px dotted #33353b;
    position: relative
}
.work__w::before,
.work__w::after {
    -webkit-transition: opacity 0.4s ease-out;
    -moz-transition: opacity 0.4s ease-out;
    -ms-transition: opacity 0.4s ease-out;
    -o-transition: opacity 0.4s ease-out;
    transition: opacity 0.4s ease-out;
    content: "";
    position: absolute;
    width: 100%;
    height: 10px;
    z-index: 2;
    top: -7px;
    left: 0;
    background: -moz-linear-gradient(left, #131418 0%, rgba(35, 37, 44, 0) 32%, rgba(35, 37, 44, 0) 75%, #131418 100%);
    background: -webkit-linear-gradient(left, #131418 0%, rgba(35, 37, 44, 0) 32%, rgba(35, 37, 44, 0) 75%, #131418 100%);
    background: linear-gradient(to right, #131418 0%, rgba(35, 37, 44, 0) 32%, rgba(35, 37, 44, 0) 75%, #131418 100%)
}
.work__w::before {
    opacity: 0;
    background: -moz-linear-gradient(left, #131418 0%, rgba(22, 24, 28, 0) 32%, rgba(22, 24, 28, 0) 75%, #131418 100%);
    background: -webkit-linear-gradient(left, #131418 0%, rgba(22, 24, 28, 0) 32%, rgba(22, 24, 28, 0) 75%, #131418 100%);
    background: linear-gradient(to right, #131418 0%, rgba(22, 24, 28, 0) 32%, rgba(22, 24, 28, 0) 75%, #131418 100%)
}
.work-block {

    color: #fff;
    margin-left: -4px;
    border-bottom: 2px dotted #33353b;



    box-sizing: border-box;
    text-align: center;


}

@media all and (min-width: 1200px) {
  .work-block {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    height: 450px;
  }
}
@media all and (max-width: 1199px) {
    .work-block {
      display: inline-block;
      padding: 80px 0 70px;
  }

}
@media all and (max-width: 768px) {
    .work-block {
      height: auto
  }
  .work__w  {
    border-top: 1px dotted rgba(100, 100, 100, 1);
  }
}


.work-block:nth-child(2n+1) {
    border-right: 2px dotted #33353b;
}
.work-block:nth-child(2n+1)::before,
.work-block:nth-child(2n+1)::after {
    left: 0;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg)
}
.work-block:nth-child(2n) {

}
.work-block:nth-child(2n)::before,
.work-block:nth-child(2n)::after {
    right: 0
}
.work-block::before,
.work-block::after {
    -webkit-transition: opacity 0.4s ease-out;
    -moz-transition: opacity 0.4s ease-out;
    -ms-transition: opacity 0.4s ease-out;
    -o-transition: opacity 0.4s ease-out;
    transition: opacity 0.4s ease-out;
    content: "";
    position: absolute;
    bottom: -8px;
    width: 200px;
    height: 10px;
    z-index: 2;
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(35, 37, 44, 0.01) 1%, #131418 100%);
    background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(35, 37, 44, 0.01) 1%, #131418 100%);
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(35, 37, 44, 0.01) 1%, #131418 100%)
}
.work-block::before {
    opacity: 0;
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(22, 24, 28, 0.01) 1%, #131418 100%);
    background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(22, 24, 28, 0.01) 1%, #131418 100%);
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(22, 24, 28, 0.01) 1%, #131418 100%)
}
.work-block::after {
    opacity: 1
}
.img__w img {
    height: 70px
}
.title {
    position: relative;
    padding-bottom: 1vw;
    font-weight: normal;
    font-family: 'ClanOT-ExtdNews';
    text-transform: lowercase;
}
.line__w {
    width: 100%;
    display: flex;
    justify-content: center;
}
.line__w .line {
    width: 40%;
    height: 1px;
    background: #f39005;
}
.line__w.special .line {
    background: #7d5683;
}
@media all and (max-width: 1199px) {
  .title {
    padding-bottom: 2vw;
  }
}
.text {
    font-size: 18px;
    opacity: .8;
    max-width: 470px;
    margin: 40px auto 0;
    min-height: 66px;
    line-height: 1.6;
}

@media all and (max-width: 768px) {
  .work-block:nth-child(2n+1) {
    border-right: none;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
    .pm_services-work {
        background: #23252c
    }
    .work-block:nth-child(2n+1) {
        padding-right: 30px;
        padding-left: 20px
    }
    .work-block:nth-child(2n) {
        padding-right: 20px;
        padding-left: 30px
    }
}
@media only screen and (min-width: 768px) and (max-width: 1199px) and (orientation: portrait) {
    .text {
        min-height: 88px
    }
}
@media all and (max-width: 768px) {
    .pm_services-work {
        background: #23252c
    }
    .work__w {
        padding-top: 15px
    }
    .work__w::after,
    .work__w::before {
        display: none
    }
    .work-block {
        width: 100%;
        border: 0 none;
        padding: 40px 10px
    }
    .work-block:nth-child(2n+1) {
        padding-right: 10px;
        padding-left: 10px
    }
    .work-block:nth-child(2n) {
        padding-right: 10px;
        padding-left: 10px
    }
    .work-block::after,
    .work-block::before {
        display: none
    }
    .title {
        padding-bottom: 5vw
    }
    .text {
        font-size: 16px;
        line-height: 24px;
        margin-top: 30px;
        text-align: justify;
    }
}
@media all and (min-width: 1200px) {
    body.dark_black-scene:not(.light_grey-scene) .work-block::before,
    body.dark_black-scene:not(.light_grey-scene) .work__w::before,
    body[data-page="pm_services"]:not(.light_grey-scene) .work-block::before,
    body[data-page="pm_services"]:not(.light_grey-scene) .work__w::before {
        opacity: 1
    }
    body.dark_black-scene:not(.light_grey-scene) .work-block::after,
    body.dark_black-scene:not(.light_grey-scene) .work__w::after,
    body[data-page="pm_services"]:not(.light_grey-scene) .work-block::after,
    body[data-page="pm_services"]:not(.light_grey-scene) .work__w::after {
        opacity: 0
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Features.vue